module.exports = __webpack_public_path__ + "img/vr.e81a127e.png";